export const isThirdPart = process.env.VUE_APP_CLIENT_ID !== '0'
